module.exports = __webpack_public_path__ + "fonts/NotoSansCJKkr-Medium.c0bdf62f.ttf";